import { WeekDay } from '@angular/common';

import { WorkingHours } from '../../api/v1/models/working-hours';

export class DateTime extends Date {
  static DAY_IN_MS = 86400000;
  static MINUTE_IN_MS = 60000;

  static range = (startDate: DateTime, endDate: DateTime, interval: number): DateTime[] => {
    const range: DateTime[] = [];
    const start = startDate.toMs();
    const finish = endDate.toMs();

    for (let date = start; date < finish; date += interval) {
      range.push(new DateTime(date));
    }
    return range;
  }

  toMs = (): number => {
    return this.getTime();
  }

  addDays = (days: number): DateTime => {
    return new DateTime(this.numAddDays(days));
  }

  numAddDays = (days: number): number => {
    return this.toMs() + days * DateTime.DAY_IN_MS;
  }

  addMinutes = (minutes: number): DateTime => {
    return new DateTime(this.numAddMinutes(minutes));
  }

  numAddMinutes = (minutes: number): number => {
    return this.toMs() + minutes * DateTime.MINUTE_IN_MS;
  }

  startOfDay = (): DateTime => {
    const date = new DateTime(this.getTime());
    date.setHours(0, 0, 0);
    return new DateTime(date);
  }

  weekDay = (): string => {
    const date = new DateTime(this.getTime());
    return WeekDay[date.getDay()]
  }

  isSameDay = (comparedDate: Date): boolean => {
    const value = new DateTime(this.getTime()).setHours(0, 0, 0, 0);
    const another = new DateTime(comparedDate).setHours(0, 0, 0, 0);

    return value === another;
  }

  endOfWorkingHours = (workingHours: WorkingHours): DateTime => {
    const now = this.getTime();
    const close = new DateTime(now).setHours(workingHours.close.hour, workingHours.close.minute, 0);
    const open = new DateTime(now).setHours(workingHours.open.hour, workingHours.open.minute, 0);

    return open < close ? new DateTime(close) : new DateTime(close).addDays(1);
  }

  startOfWorkingHours = (workingHours: WorkingHours): DateTime => {
    const now = this.getTime();
    const open = new DateTime(now).setHours(workingHours.open.hour, workingHours.open.minute, 0);

    return new DateTime(open);
  }

  getDeliveryDate(workingHours: WorkingHours): DateTime {
    const date = new DateTime(this.getTime());
    const startOfWorkingHours = date.startOfWorkingHours(workingHours);

    return date < startOfWorkingHours
      ? startOfWorkingHours.addMinutes(workingHours.deliveryDuration)
      : date.addMinutes(workingHours.deliveryDuration);
  }

}
